import React from 'react';
import Loading from '../Loading.js';
import './PokerWatchNew/Pokerwatch_new.css';
import { baseUrl } from '../common/config.js';
class TeamCreation extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            uploadedFile:null
        }}
    onChangeHandler = (event) => {
          this.setState({
            uploadedFile: event.target.files[0]
          })
      }
      onClickHandler = () => {
          this.setState({
            loading:true
          })
        if (this.state.uploadedFile != null) {
          this.setState({
            loading: true
          })
          const data = new FormData()
            data.append('files', this.state.uploadedFile)
          fetch(baseUrl + '/pokerwatch/uploadTeam', {
            method: 'POST',
            body: data,
            headers: {
              'x-access-token': localStorage.getItem('token')
            }
          }).then((response) => {
            this.setState({
              uploadedFileList: [],
              loading:false
            })
          }).catch(() => {
            
          })
        }
    
    
      }
  render() {
    {this.state.loading ? <Loading /> : null}
    return (
        <div className="file-upload-input" style={
           {
            marginLeft: '342px',
            width: '20%',
            background: 'white',
            height: '100px',
            padding: '35px',
            paddingLeft: '3%'
           }}>
    
            <button className="poker-watch-file-submit-files" onClick={this.onClickHandler}>Submit</button>
            <button className="poker-watch-choose-file-button" >Choose File   <input type="file" name="myfile" style={{ top: '41px',left: '107px'}}onChange={this.onChangeHandler} multiple /> </button>
    
          </div>

        
    //     <div className="upload-btn-wrapper">
    // <button style={{marginLeft: '1px',
    // marginTop: '20px',
    // width: '100px'}} >Choose File   <input type="file" name="myfile" onChange={this.onChangeHandler} multiple /> </button>
    
    //         <button className="btn" onClick={this.onClickHandler}
    //           >Submit</button>
            
    //       </div>
    )
  }
}

export default TeamCreation


/** WEBPACK FOOTER **
 ** ./src/components/TeamCreation.js
 **/